import { TEST_HUB_URL } from '@/constants/constants';
import { Attribute } from '@/store';
import { apiFetch } from '@/utils/apiWrapper';

const attributesUrl = `${TEST_HUB_URL}/attributes/`;

export const fetchAttributes = async (companyId: string): Promise<Attribute[]> => {
  try {
    const res = await apiFetch(`${attributesUrl}/company/${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res?.ok) {
      const data = await res.json();
      return data;
    } else {
      throw new Error('Error fetching attributes');
    }
  } catch (error) {
    console.error('Error fetching attributes:', error);
    throw error;
  }
};

export const createAttribute = async (
  attribute: Attribute,
  companyId: string,
): Promise<Attribute> => {
  try {
    const res = await apiFetch(`${attributesUrl}/${companyId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(attribute),
    });
    return res.json();
  } catch (error) {
    console.error('Error creating attribute:', error);
    throw error;
  }
};

export const updateAttribute = async (
  attribute: Attribute,
  companyId: string,
): Promise<Attribute> => {
  try {
    const res = await apiFetch(`${attributesUrl}${companyId}/${attribute._id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(attribute),
    });
    return res.json();
  } catch (error) {
    console.error('Error updating attribute:', error);
    throw error;
  }
};

export const deleteAttribute = async (attribute: Attribute, companyId: string) => {
  try {
    const res = await apiFetch(`${attributesUrl}${companyId}/${attribute._id}`, {
      method: 'DELETE',
    });
    return res.json();
  } catch (error) {
    console.error('Error deleting attribute:', error);
    throw error;
  }
};
